import { useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useQuery } from '@apollo/client'
import { uniqBy } from 'lodash'

import { Select } from 'components/v2/Select'
import { GET_ITEMS_AUTOCOMPLETE } from 'resolvers/items'

const messages = defineMessages({
  selectCategory: {
    id: 'spanish.dictionary.selectCategory',
    defaultMessage: 'Seleccionar categoría'
  }
})

export const SelectCategory = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const { data, refetch } = useQuery(GET_ITEMS_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      companyId: props.companyId
    }
  })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  const categoriesList =
    (data &&
      data.itemsAutocomplete &&
      uniqBy(data.itemsAutocomplete, ({ category }) => category)
        .map(({ category }: TSFixMe) => category)
        .sort((a, b) => a.localeCompare(b))) ||
    []

  return (
    <Select {...props}>
      <option value="">{intl.formatMessage(messages.selectCategory)}</option>

      {categoriesList.map((category: TSFixMe) => {
        return (
          <option value={category} key={category}>
            {category}
          </option>
        )
      })}
    </Select>
  )
}
